export default __webpack_public_path__ + "static/media/cabin-filter.cd657da3.jpg";